import { mapGetters } from 'vuex';
import {MQ_BREAKPOINTS} from 'jsAssets/constants/media';
import _u from 'jsAssets/utils/index';

Vue.mixin({
    computed: {
        ...mapGetters('app', [
            'user',
        ]),
    },

    methods: {
        /**
         * Дополнение к функционалу пакета {@link https://npmjs.com/package/vue-mq|vue-mq}.
         * Возвращаем `true`, если текущее разрешение экрана (`this.$mq`) меньше входящего параметра `mq`
         *
         * @memberOf vue:init
         * @method mqAbove
         * @param {string} mq - Значение разрешения экрана (см. в сторону `jsAssets/constants/media`)
         * @returns {boolean}
         */
        $mqAbove(mq) {
            return this.$mqSearch(mq);
        },

        /**
         * Дополнение к функционалу пакета {@link https://npmjs.com/package/vue-mq|vue-mq}.
         * Возвращаем `true`, если текущее разрешение экрана (`this.$mq`) больше входящего параметра `mq`
         *
         * @memberOf vue:init
         * @method mqBelow
         * @param {string} mq - Значение разрешения экрана (см. в сторону `jsAssets/constants/media`)
         * @returns {boolean}
         */
        $mqBelow(mq) {
            return !this.$mqSearch(mq);
        },

        /**
         * Дополнение к функционалу пакета {@link https://npmjs.com/package/vue-mq|vue-mq}.
         * Просматриваем массив разрешений экрана (MQ_BREAKPOINTS) указанных при инициализации пакета `vue-mq` и ищем
         * совпадение `this.$mq` с входящим параметром mq. Если значение `this.$mq` встречается в массиве ранее, чем
         * значение mq, то возвращаем `false`, иначе `true`
         *
         * @memberOf vue:init
         * @method mqSearch
         * @param {string} mq - Значение разрешения экрана (см. в сторону `jsAssets/constants/media`)
         * @returns {boolean}
         */
        $mqSearch(mq) {
            let result = false;
            let found = false;
            _.map(MQ_BREAKPOINTS, (item, index)=> {
                if (this.$mq == index) {
                    result = found;
                }
                if (mq == index) {
                    found = true;
                }
            });
            return result;
        },

        /**
         * Проверка значения. Если оно равно null, undefined, false или пустая строка, то возвращаем значение по
         * умолчанию defaultValue. В противном случае возвращаем само значение
         *
         * @memberOf js:utils
         * @param {any} value - Проверяемое значение
         * @param {any} defaultValue - Значение по умолчанию
         * @returns {any}
         */
        checkValue(value, defaultValue) {
            if (_.isBoolean(value)) {
                return value;
            } else {
                defaultValue = defaultValue ? defaultValue : '';
                return value ? value : defaultValue;
            }
        },

        /**
         * Генерируем идентификатор для html тега. Метод подключается через примеси (глобально)
         *
         * @memberOf vue:init
         * @method getHtmlId
         * @param { string } prefix - Префикс идентифкатора
         * @param { number } id - Идентифкатор элемента (или суффикс)
         * @returns { string } - Идентификатор html тега
         */
        getHtmlId(prefix, id) {
            return prefix + '_' + id
        },

        /**
         * Обработчик HTTP запросов
         *
         * @method requestHttp
         * @param {string} type - Тип HTTP запроса (get, put, post, delete)
         * @param {string} url - URL HTTP запроса
         * @param {object} params - Параметры запроса
         * @param {function} callback - Callback-функция для обработки успешного выполнения операции
         * @param {function} callbackError - Callback-функция для обработки ошибок HTTP запроса
         */
        requestHttp(type, url, params, callback, callbackError) {
            params = _u.checkValue(params, {});

            // отключение кеширования ajax-запросов
            params.timestamp = Date.now();

            _u.requestHttp(type, url, params, (response) => {
                if (response.status == 200) {
                    if (_.isFunction(callback)) callback(response.data);
                } else {
                    if (_.isFunction(callbackError)) callbackError(response);
                }
            }, (error) => {
                if (error.response) {
                    if (_.isFunction(callbackError)) callbackError(error);
                }
            });
        },

    }
});
